import { connect } from 'react-redux'
import { changeRecruitersKeyword, changeTagsKeyword, moveRecruitersPage, moveTagsPage } from '../actions'
import Selector from '../components/selector'

const mapStateToProps = ({ recruiter, tag, special }) => ({
  recruiters: recruiter.recruiters,
  recruitersPagination: recruiter.pagination,
  isLoadingRecruiters: recruiter.isLoading,
  tags: tag.tags,
  tagsPagination: tag.pagination,
  isLoadingTags: tag.isLoading,
  specials: special.specials,
  isLoadingSpecials: special.isLoading
})

const mapDispatchToProps = dispatch => ({
  onChangeRecruitersPage: page => dispatch(moveRecruitersPage(page)),
  onChangeRecruitersKeyword: keyword => dispatch(changeRecruitersKeyword(keyword)),
  onChangeTagsPage: page => dispatch(moveTagsPage(page)),
  onChangeTagsKeyword: keyword => dispatch(changeTagsKeyword(keyword))
})

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Selector)

export default connected
